<template>
	<page>
		<module>
            <view-list :work-type="workType" ref="view" selector :view-config="auth('b_out_sourcing_recruit_viewmanage')">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="单据编号">
                            <c-input name="recruit_number"></c-input>
                        </m-search-item>
                        <m-search-item label="客户名称">
                            <c-input name="customer_name"></c-input>
                        </m-search-item>
                        <m-search-item label="紧急程度">
                            <c-select name="urgency_level" :options="urgencyLevelDic" multiple></c-select>
                        </m-search-item>
                        <m-search-item label="招工类型">
                            <c-select name="recruit_type" :options="recruitTypeDic" multiple></c-select>
                        </m-search-item>
                        <m-search-item label="申请人">
                            <c-input name="create_user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="审批状态">
                            <c-select name="status" :options="applyStatusDic" multiple></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_out_sourcing_recruit_edit')" prepend-icon="tf-add" @click="editOrder()">创建外协招工单</c-button>
                    <c-button v-if="auth('b_out_sourcing_recruit_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_out_sourcing_recruit_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button color="main" prepend-icon="tf-success" @click="batchApprove(data, 1)">批量通过</c-button>
                    <c-button prepend-icon="tf-reject" @click="batchApprove(data, 9)">批量驳回</c-button>
                </template>

                <template #otherOperate>
                    <c-button prepend-icon="tf-operate-record" v-if="auth('b_out_sourcing_recruit_log')" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
                </template>
                <!--单据编号-->
                <template #recruit_number="{data}">
                    <c-link @click="globalDialog('outsourceRrecruitDetail', {props: {id: data.id}})">{{data.recruit_number}}</c-link>
                </template>
                <!--关联工单编号-->
                <template #order_number="{data}">
                    <c-link @click="globalDialog('afterSaleOrderDetail', {props: {id: data.order_id}})">{{data.order_number}}</c-link>
                </template>

                <!--紧急程度-->
                <template #urgency_level="{data}">
                    <c-state dict="urgencyLevelDic" tag :value="data.urgency_level"></c-state>
                </template>

                <!--外协类型-->
                <template #recruit_type="{data}">
                    <c-state dict="recruitTypeDic"  :value="data.recruit_type"></c-state>
                </template>

                <!--审批状态-->
                <template #status="{data}">
                    <c-state dict="applyStatusDic" :value="data.status"></c-state>
                </template>

                <!--所需费用-->
                <template #required_fee="{data}">
                    ￥{{data.required_fee}}
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="175"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_out_sourcing_recruit_edit')" :disabled="!(data.status == -1||data.status == 3)" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
                        <c-table-button icon="tf-detail" @click="globalDialog('outsourceRrecruitDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_out_sourcing_recruit_edit')" :disabled="!(data.status == -1)" icon="tf-trash" @click="removeOrder(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--创建、编辑售后工单信息弹窗-->
			<outsourcing-recruit-edit ref="outsourcingRecruitEdit" @resolve="updateMethod"></outsourcing-recruit-edit>
			<!--批量驳回弹窗-->
			<c-dialog ref="rejectDialog" title="批量驳回" width="500" height="200" @resolve="batchRejectHandle">
				<c-form ref="rejectForm" vertical unit-width="100%">
					<c-form-item label="驳回原因">
						<c-input name="remark" type="textarea" :rows="3" placeholder="请输入驳回原因"></c-input>
					</c-form-item>
				</c-form>
			</c-dialog>
		</module>
	</page>
</template>

<script>
    import {mapState} from 'vuex'
    import outsourcingRecruitEdit from '@/pages/aftersale/out_sourcing_recruit_edit.vue'
	export default {
		components: {
            outsourcingRecruitEdit,
		},
		
		data() {
			return {
				editFlag: false,
                workType: 9,
                view_id: 10009,
                order_id:0,
                estimated_service_days:1,       //预计服务时长（天）
                appointment_time:[],            //服务起止时间
			}
		},

        mounted() {
            this.$bus.$on('outsource_recruit_list.update', data => {
                // 刷新列表
                this.$refs.view.$refs.list.refresh();
                // 刷新二级分组数量
                this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
            });
        },

		computed: {
			// 获取dictName选项数据
			...mapState(['urgencyLevelDic',"recruitTypeDic","applyStatusDic"])
		},
		
		methods: {
			
			updateMethod(){
				//修改
				if(this.editFlag){
					this.$refs.view.$refs.list.refresh();
				}else{
					this.$refs.view.$refs.list.update();
				}
			},
			
			/******新建/编辑售后工单*******/
			editOrder(data) {
				if(data){
					this.editFlag = true;
				}else{
					this.editFlag = false;
				}
				this.$refs.outsourcingRecruitEdit.open(data);
			},
			
			/******复制售后工单*******/
			copyOrder(data) {
				this.$refs.outsourcingRecruitEdit.open(data, true);
			},

            //选择服务起止时间
            changeAppointmentTime(data){
                const start = new Date(data[0]);
                const end = new Date(data[1]);
                const difference = end - start; // 时间差，单位毫秒
                //取天数（向上取整）
                const days = Math.ceil(difference / 3600000 / 24) + 1;
                this.estimated_service_days = days;
            },

            /************搜索用户*******************************/
            searchUser(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
            //选择团队成员响应方法
            addOrderMemberHandle(stop, next) {
                this.$refs.orderMemberForm.submit({
                    url: '/after/sale/order/add_member',
                    dataFormatter: data => {
                        data.order_id = this.order_id
                        return data;
                    },
                    rule: {
                        member_list: '请至少选择一个团队成员'
                    },
                    success: (data, res) => {
                        next();
                        this.$message({
                            message: '添加成员成功',  // 提示内容,
                            type: 'success'
                        });
                        this.$emit('resolve');
                    }
                });
            },
            //修改预约时间响应方法
            orderAppointmentHandle(stop, next) {
                this.$refs.orderAppointmentForm.submit({
                    url: '/after/sale/order/edit/appointment_time',
                    dataFormatter: data => {
                        data.order_id = this.order_id
                        data.appointment_start_time = data.appointment_start_time + ' 00:00:00';
                        data.appointment_end_time = data.appointment_end_time + ' 23:59:59';
                        data.order_id = this.order_id
                        return data;
                    },
                    rule: {
                        estimated_service_days: '请填写预计服务时长',
                        appointment_start_time: '请选择客户预约时间',
                        appointment_end_time: '请选择客户预约时间'
                    },
                    success: (data, res) => {
                        next();
                        this.$message({
                            message: '修改预约时间成功',  // 提示内容,
                            type: 'success'
                        });
                        this.$emit('resolve');
                    }
                });
            },

            /******删除售后工单************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除售后工单【'+data.order_number+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/after/sale/order/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.$refs.list.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			batchApprove(data, executeState) {
				if (!data || !data.length) {
					this.$message({message: '请至少选择一条数据'});
					return;
				}
				let invalidList = data.filter(item => item.status != 1);
				if (invalidList.length) {
					let nums = invalidList.map(item => item.recruit_number || item.id).join('、');
					this.$message({message: '以下单据非审批中状态，无法操作：' + nums, type: 'warning'});
					return;
				}
				let orderIds = data.map(item => item.id);
				if (executeState == 1) {
					this.$confirm({
						message: '确定要批量通过选中的 ' + data.length + ' 条外协招工单吗？',
						buttonName: '确定',
						cancelButton: true,
						resolve: () => {
							this.request({
								url: '/workflow/order/batch/approve',
								data: {
									order_type: 2,
									execute_state: executeState,
									order_ids: orderIds
								},
								loading: true,
								success: (data, msg) => {
									let message = msg || '批量审批成功';
									if (data && data.fail_list && data.fail_list.length) {
										let details = data.fail_list.map(item => item.reason).join('；');
										message += '\n' + details;
									}
									this.$message({message: message, type: data && data.fail_count ? 'warning' : 'success'});
									this.$refs.view.batchCancelHandle();
									setTimeout(() => {
										this.$refs.view.$refs.list.update();
										this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
									}, 3000);
								}
							});
						},
						cancel: () => {},
					});
				} else {
					this._batchOrderIds = orderIds;
					this.$refs.rejectForm.clear();
					this.$refs.rejectDialog.open();
				}
			},

			batchRejectHandle(stop) {
				stop();
				this.$refs.rejectForm.validate({
					rule: {
						remark: '请输入驳回原因'
					},
					success: formData => {
						this.request({
							url: '/workflow/order/batch/approve',
							data: {
								order_type: 2,
								execute_state: 9,
								order_ids: this._batchOrderIds,
								remark: formData.remark
							},
							loading: true,
							success: (data, msg) => {
								let message = msg || '批量驳回成功';
								if (data && data.fail_list && data.fail_list.length) {
									let details = data.fail_list.map(item => item.reason).join('；');
									message += '\n' + details;
								}
								this.$message({message: message, type: data && data.fail_count ? 'warning' : 'success'});
								this.$refs.rejectDialog.close();
								this.$refs.view.batchCancelHandle();
								setTimeout(() => {
									this.$refs.view.$refs.list.update();
									this.$refs.view.updateTabTotal && this.$refs.view.updateTabTotal();
								}, 3000);
							}
						});
					}
				});
			},

            /*******导入数据************/
            importData() {
                this.$refs.view.excelImport(Object.assign({}, {
                    view_id: this.view_id
                }));
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>